import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCostCategoryAvailableColumns, getServiceTypeListAllNotDeleted } from './api';

export const path = '/cost-category/list';

const PageCostCategoryList: React.FC = (props) => {
  const CostCategory = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCostCategoryAvailableColumns,
      serviceTypes: getServiceTypeListAllNotDeleted,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CostCategory {...props} />;
};

export default PageCostCategoryList;
